import { useEffect, useCallback } from 'react';
import { useRoutes } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@store';
import { setActivePermissions } from './store/dictionaries/slice';
import Reports from './hoc/reports/reports';
import Safeguarding from './hoc/safeguarding/safeguarding';
import CapitalAdequacy from './hoc/capital-adequacy/capital-adequacy';
import BankAndPsp from './hoc/bank-and-psp/bank-and-psp';
import CurrencyPosition from './hoc/currency-position/currency-position';
import AccountsBalanceReport from './hoc/balance/accounts-report';
import Revaluation from './hoc/revaluation/revaluation';
import BalanceRoutes from './routes/balance';
import ProfitLoss from './routes/profit-loss';
import TransactionStatusReport from './hoc/transaction-status/list';
import NotificationCenter from './hoc/notification-center/notification-center';
import WarningsReportRoutes from './routes/warnings-report';
import AccountingManagmentRoutes from './routes/accounting-managment';
import FintracRoutes from './routes/fintrac';

import {
  useLazyGetReportsPermissionsQuery,
  useLazyGetReportsWhitelabelQuery,
} from './store/dictionaries/service';
import SafeguardingFiat from './hoc/safeguarding/fiat';
import SafeguardingCrypto from './hoc/safeguarding/crypto';

import ROUTES from './routes';

export const routes = {
  path: ROUTES.REPORTS,
  element: <Reports />,
  children: [
    { ...BalanceRoutes },
    { ...ProfitLoss },
    { ...WarningsReportRoutes },
    { ...AccountingManagmentRoutes },
    { ...FintracRoutes },
    {
      path: ROUTES.REPORTS_SAFEGUARDING,
      element: <Safeguarding />,
      children: [
        {
          path: ROUTES.REPORTS_SAFEGUARDING_FIAT,
          element: <SafeguardingFiat />,
        },
        {
          path: ROUTES.REPORTS_SAFEGUARDING_CRYPTO,
          element: <SafeguardingCrypto />,
        },
      ],
    },
    {
      path: ROUTES.REPORTS_CAPITAL_ADEQUACY,
      element: <CapitalAdequacy />,
    },
    {
      path: ROUTES.REPORTS_BANK_AND_PSP,
      element: <BankAndPsp />,
    },
    {
      path: ROUTES.REPORTS_CURRENCY_POSITION,
      element: <CurrencyPosition />,
    },
    {
      path: ROUTES.REPORTS_ACCOUNTS_BALANCE,
      element: <AccountsBalanceReport />,
    },
    {
      path: ROUTES.REPORTS_REVALUATION,
      element: <Revaluation />,
    },
    {
      path: ROUTES.TRANSACTION_STATUS_REPORT,
      element: <TransactionStatusReport />,
    },
    {
      path: ROUTES.REPORTS_NOTIFICATIONS_CENTER,
      element: <NotificationCenter />,
    },
  ],
};

const ReportsRoutes = () => {
  const elements = useRoutes([{ ...routes }]);

  const dispatch = useAppDispatch();

  const { activePermissions, whitelabel } = useAppSelector(
    (state) => state.reportsDictionaries,
  );

  const [getReportsPermissions] = useLazyGetReportsPermissionsQuery();
  const [getReportsWhiteLabel] = useLazyGetReportsWhitelabelQuery();

  const getReportsPermissionsAction = useCallback(() => {
    getReportsPermissions();
  }, []);

  const permissions = JSON.parse(
    localStorage.getItem('activePermissions') as string,
  );

  useEffect(() => {
    const companyName = localStorage.getItem('companyName');

    if (!companyName) {
      getReportsWhiteLabel();
    }
  }, []);

  useEffect(() => {
    if (whitelabel) {
      localStorage.setItem('companyName', whitelabel?.data?.value?.companyName);
    }
  }, [whitelabel]);

  useEffect(() => {
    if (permissions && !activePermissions) {
      dispatch(setActivePermissions(permissions));
    } else if (!permissions && !activePermissions) {
      getReportsPermissionsAction();
    }
  }, [permissions, getReportsPermissionsAction, dispatch, activePermissions]);

  return elements;
};

export default ReportsRoutes;
